const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const PotencyCircles = ({ value, text, containerStyles }) => {
  let circles = [];
  for (let i = 0; i < 5; i++) {
    // Check for the fractional circle
    if (i < Math.floor(value)) {
      circles.push(
        <div
          key={i}
          css={styles.circle}
        />
      );
    } else if (i === Math.floor(value) && value % 1 !== 0) {
      // Handle half circle
      circles.push(
        <div
          key={i}
          css={styles.half}
        >
          <div
            css={{
              position: "absolute",
              top: 0,
              left: "50%",
              width: "50%",
              height: "100%",
              backgroundColor: "#d9d9d9",
            }}
          />
        </div>
      );
    } else {
      // Empty circle
      circles.push(
        <div
          key={i}
          css={styles.empty}
        />
      );
    }
  }
  return (
    <div css={{ display: "flex", alignContent: "center", alignItems: "center", ...containerStyles }}>
      {text && <div css={styles.text}>{text}</div>}
      {circles}
    </div>
  );
};

const styles = {
  circle: {
    fontSize: "1.5rem",
    color: "#06ca49",
    width: 13,
    height: 13,
    background: "#9c03c3",
    marginRight: 2,
    borderRadius: "50%",
    [mq[0]]: {
      fontSize: "2rem",
    },
  },
  half: {
    fontSize: "1.5rem",
    color: "#06ca49",
    width: 13,
    height: 13,
    background: "#9c03c3",
    marginRight: 2,
    borderRadius: "50%",
    position: "relative",
    overflow: "hidden",
    [mq[0]]: {
      fontSize: "2rem",
    },
  },
  empty: {
    fontSize: "1.5rem",
    color: "#06ca49",
    width: 13,
    height: 13,
    background: "#d9d9d9",
    marginRight: 2,
    borderRadius: "50%",
    [mq[0]]: {
      fontSize: "2rem",
    },
  },
  text: {
    fontSize: ".9rem",
    fontWeight: 400,
    marginRight: 10,
    [mq[0]]: {
      fontSize: "1.1rem",
    },
  }
}

export default PotencyCircles;
